import { Container, Paper, TypographyElement, Button, Icon, Icons, MediaQuery } from 'UI'
import VideoPlayer from 'components/common/VideoPlayer'
import { TwitterShareLink, LinkdinShareLink, FacebookShareLink } from 'constants/'
import { useRef, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'
import SocialMedia from 'components/common/SocialMedia'

const useStyles = createUseStyles(style)

export default ({
  Title,
  PresentationVideoThumbnail,
  PresentationVideo,
  onAccessLearningPathClick,
  showPopUp,
  setShowPopUp,
  showPricing
}) => {
  const { overlay, wrapper, closeIcon, header, title, button, video, videoInner, socialMedia } = useStyles()
  const theme = useTheme()
  const escAndEnterFunction = ({ keyCode }) => keyCode === 27 && setShowPopUp(false)
  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', escAndEnterFunction)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', escAndEnterFunction)
    }
  }, [])

  const node = useRef()
  const handleClick = e => node && node.current && !node.current.contains(e.target) && setShowPopUp(false)

  if (!showPopUp) return null

  return (
    <div className={overlay}>
      <div className={wrapper} ref={node}>
        <Container>
          <MediaQuery ShowOnDesktop>
            <div className={closeIcon}>
              <Icon iconName={Icons.close} onHandleIconClick={() => setShowPopUp(false)} />
            </div>
            <Paper noHover className={header}>
              <TypographyElement
                className={title}
                variant='heading4'
              >
                {Title}
              </TypographyElement>
              {
                showPricing
                  ? <Button
                      className={button}
                      variation='confirmation'
                      height={54}
                      label={Text.accessToTheLearningPath}
                      onHandleClick={() => {
                        setShowPopUp(false)
                        onAccessLearningPathClick()
                      }}
                    />
                  : null
              }
            </Paper>
          </MediaQuery>
          <div className={video}>
            <div className={videoInner}>
              <VideoPlayer posterLink={PresentationVideoThumbnail} videoLink={PresentationVideo} mp4 defaultAutoPlay />
            </div>
          </div>
          <MediaQuery ShowOnDesktop>
            <div className={socialMedia}>
              <SocialMedia
                title={Text.shareOnSocialMedia}
                textProps={{
                  color: theme.secondary[500],
                  variant: 'body2'
                }}
                shareLinks={{
                  facebookShareLink: `${FacebookShareLink}${window.location}`,
                  twitterShareLink: `${TwitterShareLink}${window.location}`,
                  linkedinShareLink: `${LinkdinShareLink}${window.location}`
                }}
              />
            </div>
          </MediaQuery>
        </Container>
      </div>
    </div>
  )
}
